import { resolveImageAltText } from '@/lib/utils';

export function renderArticleBanner(_attrs, _child, jsonBlock) {
  const entryData = jsonBlock.entryData;
  if (!entryData || !entryData.image?.url) {
    console.warn(
      'Article banner entry data is incomplete',
      jsonBlock?.uid ?? ''
    );
    return '';
  }

  return `
    <div class="article-banner text-white mx-auto my-10 sm:my-15 sm:bg-[${entryData.background_color_picker ? entryData.background_color_picker : 'parlor-green'}] sm:flex sm:w-full">
      <div class="sm:bg-white sm:relative sm:h-[197px] sm:w-full sm:overflow-hidden">
        ${
          entryData.link?.href
            ? `
              <a href="${entryData.link.href}">
                  <img 
                    src="${entryData.image.url || 'default-image.jpg'}" 
                    alt="${resolveImageAltText(entryData.image)}" 
                    width="${entryData.image.dimension?.width || 300}" 
                    height="${entryData.image.dimension?.height || 300}" 
                    class="bg-white hover:opacity-60 transition ease-in-out delay-100 w-full sm:object-cover sm:object-center sm:w-full sm:h-full"
                  />
              </a>
            `
            : `
              <img 
                src="${entryData.image.url || 'default-image.jpg'}" 
                alt="${resolveImageAltText(entryData.image)}" 
                width="${entryData.image.dimension?.width || 300}" 
                height="${entryData.image.dimension?.height || 300}" 
                class="w-full sm:object-cover sm:object-center"
              />
            `
        }
      </div>
      <div class="px-3 py-4 bg-[${entryData.background_color_picker ? entryData.background_color_picker : 'parlor-green'}] sm:px-4 sm:bg-transparent">
        <h3 class="sh11 pb-4 sm:sh10">${entryData.title || ''}</h3>
        <div class="body-r pr-1 pb-6 sm:pb-0">
          <span class="pr-1">${entryData.caption || ''}</span>
          ${
            entryData.link?.title
              ? `<span class="pl-1 sm:pl-0">
                <a class="hover:text-cozy-cognac font-black sm:font-bold" href="${entryData.link?.href}">${entryData.link.title}</a>
              </span>`
              : ''
          }
        </div>
      </div>
    </div>
  `;
}
